export type CepAddress = {
  postalCode: string;
  address: string;
  district: string;
  city: string;
  state: string;
};

type ViaCepResponse = {
  cep?: string;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean;
};

export function normalizeCep(
  value: string,
) {
  return value.replace(/\D/g, "").slice(0, 8);
}

export function formatCep(
  value: string,
) {
  const digits = normalizeCep(value);

  if (digits.length <= 5) {
    return digits;
  }

  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

export async function lookupCep(
  value: string,
): Promise<CepAddress> {
  const cep = normalizeCep(value);

  if (cep.length !== 8) {
    throw new Error(
      "Informe um CEP com 8 dígitos.",
    );
  }

  const response = await fetch(
    `https://viacep.com.br/ws/${cep}/json/`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error(
      "Não foi possível consultar o CEP.",
    );
  }

  const data =
    (await response.json()) as ViaCepResponse;

  if (data.erro) {
    throw new Error(
      "CEP não encontrado.",
    );
  }

  return {
    postalCode: cep,
    address: data.logradouro ?? "",
    district: data.bairro ?? "",
    city: data.localidade ?? "",
    state: data.uf ?? "",
  };
}
